import React from 'react';
import ErrorUnhandled from './ErrorUnhandled';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`Unhandled Error:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorUnhandled />;
    }
    return this.props.children; 
  }
}
export default ErrorBoundary;
